import { IBankDetail } from "src/app/models/registration/bankDetails";

/*
    Use this when BankDetails becomes an array

import { IBankDetail } from 'src/app/models/registration/bankDetails';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export interface IBankDetailsState extends EntityState<IBankDetail> {
    failText: string;
}

export const bankDetailAdapter: EntityAdapter<IBankDetail> = createEntityAdapter<IBankDetail>({
    selectId: (i: IBankDetail) => i.id
});

export const initialBankDetailsState: IBankDetailsState = bankDetailAdapter.getInitialState({
    failText: ''
});
*/

export interface IBankDetailsState {
    details: IBankDetail;
    failText: string | null;
}

export const initialBankDetailsState: IBankDetailsState = {
    details: undefined,
    failText: null
};
